//----- Component --------------------------------------------------------/
// Developer : Nicolas Pascucci
// Creation Date : 21/05/2024
// Version : 1
// Description : dialog para agregar un monto general para los comerciales x porcentaje
//------Changes --------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useState, useEffect } from "react";
import { UrlApi } from "../../../services/apirest";
import {
  Button,
  Container,
  Dialog,
  DialogContent,
  Box,
  Grid,
  Stack,
  TextField,
  Autocomplete,
  Snackbar,
  Alert,
  Typography,
  List,
  ListItem,
  ListItemText,
  DialogTitle,
} from "@mui/material";
import moment from "moment"; // PARA LA FECHA
//adjuntado
import AttachFileIcon from "@mui/icons-material/AttachFile"; //ADJUNTAR ARCHIVOS
import { grey } from "@mui/material/colors";
import Title from "../../Title";
import { v4 as uuidv4 } from "uuid";
import { logEventos } from "../../../services/services";
import "dayjs/locale/es";
import ConfirmarSobrescrituraDialog from "./ConfirmarSobrescrituraDialog";

function AgregaMontoGeneral(props) {
  const [montoGeneral, setMontoGeneral] = useState(props.montoGeneral);
  const [datosRow, setDatosRow] = useState(props.datosRow);
  const [porcentaje, setPorcentaje] = useState({
    porcentaje: null,
  });
  const [objetivosSeleccionado, setObjetivosSeleccionado] = useState();
  const [objetivosPasados, setObjetivosPasados] = useState();
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [objetivosNoActualizados, setObjetivosNoActualizados] = useState({
    faltantesPasado: [],
    faltantesSeleccionado: [],
  });
  const [openDialog, setOpenDialog] = useState(false); // Estado para controlar el diálogo
  const [objetivosConMonto, setObjetivosConMonto] = useState([]);

  // Lógica para abrir el diálogo de confirmación
  const abrirDialogoConfirmacion = (objetivos) => {
    setObjetivosConMonto(objetivos);
    setOpenDialog(true);
  };

  useEffect(() => {
    if (objetivosPasados && objetivosSeleccionado) {
      const faltantesPasado = objetivosPasados.filter(
        (pas) =>
          !objetivosSeleccionado.some(
            (sel) =>
              sel.comercial === pas.comercial && sel.sucursal === pas.sucursal
          )
      );

      const faltantesSeleccionado = objetivosSeleccionado.filter(
        (sel) =>
          !objetivosPasados.some(
            (pas) =>
              pas.comercial === sel.comercial && pas.sucursal === sel.sucursal
          )
      );

      setObjetivosNoActualizados({
        faltantesPasado,
        faltantesSeleccionado,
      });
    }
  }, [objetivosPasados, objetivosSeleccionado]);
  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const getFormattedDate = (selectedDate) => {
    if (!selectedDate) return ""; // Manejar caso donde selectedDate es null o undefined

    const [year, month] = selectedDate.split("-").map(Number); // Separar año y mes
    const newDate = new Date(year, month - 2, 1); // Restamos 1 mes (mes en JS es 0-indexado)

    const formattedYear = newDate.getFullYear();
    const formattedMonth = String(newDate.getMonth() + 1).padStart(2, "0"); // Asegurar dos dígitos

    return `${formattedYear}-${formattedMonth}-01`;
  };

  const formattedDate = getFormattedDate(selectedDate);
  const mesSeleccionado = `${selectedDate}-01`;

  // console.log("selected date", selectedDate);
  // console.log("formattedDate", formattedDate);

  const obtenerObjetivosSeleccionado = () => {
    fetch(UrlApi + "/objetivos_comerciales/mes/" + mesSeleccionado)
      .then((data) => data.json())
      .then((data) => setObjetivosSeleccionado(data));
  };

  useEffect(() => {
    obtenerObjetivosSeleccionado();
  }, [mesSeleccionado]);

  const obtenerObjetivosPasados = () => {
    fetch(UrlApi + "/objetivos_comerciales/mes/" + formattedDate)
      .then((data) => data.json())
      .then((data) => setObjetivosPasados(data));
  };

  useEffect(() => {
    obtenerObjetivosPasados();
  }, [formattedDate]);
  // console.log("pasado", objetivosPasados);
  // console.log("seleccionado", objetivosSeleccionado);

  const encontrarCoincidencias = () => {
    if (!objetivosSeleccionado || !objetivosPasados) return [];

    return objetivosSeleccionado.filter((sel) =>
      objetivosPasados.some(
        (pas) =>
          pas.comercial === sel.comercial && pas.sucursal === sel.sucursal
      )
    );
  };

  const coincidencias = encontrarCoincidencias();
  // console.log("Coincidencias:", coincidencias);

  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    handleClose()
  };

  const handleClose = () => {
    setMontoGeneral(!montoGeneral);
    if (props.onClose) {
      props.onClose();
    }
  };

  const almacenar = (e) => {
    setPorcentaje({
      ...porcentaje,
      [e.target.name]: e.target.value,
    });
  };

  // const calcularMontosActualizados = () => {
  //   if (!objetivosSeleccionado || !objetivosPasados || !porcentaje.porcentaje)
  //     return [];

  //   const porcentajeDecimal = parseFloat(porcentaje.porcentaje) / 100;

  //   return objetivosSeleccionado.map((sel) => {
  //     const objetivoPasado = objetivosPasados.find(
  //       (pas) =>
  //         pas.comercial === sel.comercial && pas.sucursal === sel.sucursal
  //     );

  //     if (objetivoPasado) {
  //       const montoPasado = objetivoPasado.monto_pesos || 0;
  //       return {
  //         ...sel,
  //         monto_pesos: montoPasado + montoPasado * porcentajeDecimal, // Actualiza monto_pesos
  //       };
  //     }

  //     return sel;
  //   });
  // };

  // const objetivosActualizados = calcularMontosActualizados();

  // Evita que se ejecute si los datos aún no están cargados
  // const objetivosFaltantesPasado =
  //   objetivosPasados && objetivosSeleccionado
  //     ? objetivosPasados.filter(
  //         (pas) =>
  //           !objetivosSeleccionado.some(
  //             (sel) =>
  //               sel.comercial === pas.comercial && sel.sucursal === pas.sucursal
  //           )
  //       )
  //     : [];


  // const objetivosFaltantesSeleccionado =
  //   objetivosPasados && objetivosSeleccionado
  //     ? objetivosSeleccionado.filter(
  //         (sel) =>
  //           !objetivosPasados.some(
  //             (pas) =>
  //               pas.comercial === sel.comercial && pas.sucursal === sel.sucursal
  //           )
  //       )
  //     : [];


// Lógica para actualizar los objetivos seleccionados
const actualizarObjetivosSeleccionados = async (objetivosSeleccionados) => {
    try {
      // Actualizar los objetivos seleccionados por el usuario
      const respuestasSeleccionados = await Promise.all(
        objetivosSeleccionados.map(async (objetivo) => {
          const objetivoPasado = objetivosPasados.find(
            (pas) =>
              pas.comercial === objetivo.comercial &&
              pas.sucursal === objetivo.sucursal
          );
  
          if (!objetivoPasado) {
            // console.log(
            //   `No se encontró el monto del mes pasado para ${objetivo.comercial} - ${objetivo.sucursal}`
            // );
            return null;
          }
  
          const montoPasado = objetivoPasado.monto_pesos || 0;
          const nuevoMonto =
            montoPasado + montoPasado * (parseFloat(porcentaje.porcentaje) / 100);
  
          return fetch(`${UrlApi}/objetivos_comerciales/${objetivo.id_objetivo}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ monto_pesos: nuevoMonto }),
          });
        })
      );
  
      // Filtrar los objetivos que tienen monto_pesos en null
      const objetivosConMontoNull = coincidencias.filter(
        (obj) => obj.monto_pesos === null || obj.monto_pesos === undefined
      );
  
      // Actualizar los objetivos con monto_pesos en null
      const respuestasMontoNull = await Promise.all(
        objetivosConMontoNull.map(async (objetivo) => {
          const objetivoPasado = objetivosPasados.find(
            (pas) =>
              pas.comercial === objetivo.comercial &&
              pas.sucursal === objetivo.sucursal
          );
  
          if (!objetivoPasado) {
            // console.log(
            //   `No se encontró el monto del mes pasado para ${objetivo.comercial} - ${objetivo.sucursal}`
            // );
            return null;
          }
  
          const montoPasado = objetivoPasado.monto_pesos || 0;
          const nuevoMonto =
            montoPasado + montoPasado * (parseFloat(porcentaje.porcentaje) / 100);
  
          return fetch(`${UrlApi}/objetivos_comerciales/${objetivo.id_objetivo}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ monto_pesos: nuevoMonto }),
          });
        })
      );
  
      // Combinar las respuestas de ambas actualizaciones
      const respuestas = [...respuestasSeleccionados, ...respuestasMontoNull];
  
      // Verificar si todas las peticiones fueron exitosas
      const exitosos = respuestas.every((res) => res && res.ok);
      if (exitosos) {
        setOpenSnack(true);
        setColorMensaje("#D4EFDF");
        setMensaje("Todos los objetivos se actualizaron exitosamente.");
        console.log("Actualización completada");
      } else {
        setOpenSnack(true);
        setColorMensaje("#F1948A");
        setMensaje("Hubo un error en alguna actualización.");
        console.log("Error en la actualización");
      }
    } catch (error) {
      console.error("Error al actualizar objetivos:", error);
      setOpenSnack(true);
      setColorMensaje("#F1948A");
      setMensaje("Error al editar los objetivos.");
    }
  };

  // Lógica principal para actualizar objetivos
  const actualizarObjetivos = async () => {
    if (!coincidencias.length) {
      // console.log("No hay coincidencias para actualizar.");
      return;
    }

    // Filtrar objetivos que ya tienen un monto registrado
    const objetivosConMontoRegistrado = coincidencias.filter(
      (obj) => obj.monto_pesos !== null && obj.monto_pesos !== undefined
    );

    if (objetivosConMontoRegistrado.length > 0) {
      // Si hay objetivos con monto registrado, abrir el diálogo de confirmación
      abrirDialogoConfirmacion(objetivosConMontoRegistrado);
    } else {
      // Si no hay objetivos con monto registrado, actualizar todos
      actualizarObjetivosSeleccionados(coincidencias);
    }

    // handleClose();
  };

  return (
    <>
      <ConfirmarSobrescrituraDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        objetivos={objetivosConMonto}
        onConfirm={actualizarObjetivosSeleccionados}
      />
      <Dialog
        open={montoGeneral}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        color="#F4F6F6"
        maxWidth="md"
      >
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography fontSize={20} align="center" color="#ffffff">
              Monto General
            </Typography>
          </DialogTitle>
        </Box>
        <Box
          border={0.5}
          borderColor={grey[300]}
          backgroundColor="#F4F6F6"
          p={2}
          py={2}
          mt={1}
        >
              <form autoComplete="off" onSubmit={(e) => {
                e.preventDefault(); // Evitar el envío predeterminado del formulario
                actualizarObjetivos(); // Llamar a la función para actualizar objetivos
              }}>
          <DialogContent>
            <Container>
                <Grid container mb={1} spacing={1}>
                  <Grid
                    item
                    xs={12}
                    alignContent={"center"}
                    justifyContent={"center"}
                    display={"flex"}
                  >
                    {selectedDate === "" ? (
                      <Typography variant="h5" alignContent={"center"}>
                        Seleccione un periodo
                      </Typography>
                    ) : (
                      <Typography variant="h6" alignContent={"center"}>
                        Vas a agregar montos a los objetivos correpondientes al
                        mes de {moment(selectedDate).format("MMMM YYYY")}
                      </Typography>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    mb={1}
                    alignContent={"center"}
                    justifyContent={"center"}
                    display={"flex"}
                  >
                    <TextField
                      focused
                      size="small"
                      label="Período"
                      type="month"
                      value={selectedDate}
                      onChange={handleDateChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} py={1} mb={1}>
                    <TextField
                      label="Porcentaje de Aumento"
                      name="porcentaje"
                      size="small"
                      placeholder="..."
                      onKeyPress={(event) => {
                        if (!/[0-9.]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      inputProps={{
                        maxLength: 10,
                      }}
                      focused
                      required
                      fullWidth
                      value={porcentaje.porcentaje}
                      onChange={almacenar}
                    />
                  </Grid>
                </Grid>
                <Box mt={2} mb={2}>
                  {(objetivosNoActualizados.faltantesSeleccionado.length > 0 ||
                    objetivosNoActualizados.faltantesPasado.length > 0) && (
                    <Box
                      border={1}
                      borderColor="divider"
                      borderRadius={2}
                      boxShadow={1}
                      p={2}
                      bgcolor="background.paper"
                    >
                      <Typography variant="h6" gutterBottom>
                        Montos que no se van a actualizar:
                      </Typography>

                      {objetivosNoActualizados.faltantesSeleccionado.length >
                        0 && (
                        <>
                          <Typography
                            variant="subtitle1"
                            gutterBottom
                            fontWeight="bold"
                          >
                            Faltantes en el mes seleccionado:
                          </Typography>
                          <List dense>
                            {objetivosNoActualizados.faltantesSeleccionado.map(
                              (obj) => (
                                <ListItem key={obj.id_objetivo}>
                                  <ListItemText
                                    primary={`${obj.nombre_apellido} - ${obj.nombre_sucursal}`}
                                    secondary={
                                      obj.monto_pesos
                                        ? `$${obj.monto_pesos}`
                                        : "No registrado"
                                    }
                                  />
                                </ListItem>
                              )
                            )}
                          </List>
                        </>
                      )}

                      {objetivosNoActualizados.faltantesPasado.length > 0 && (
                        <>
                          <Typography
                            variant="subtitle1"
                            gutterBottom
                            fontWeight="bold"
                          >
                            Faltantes en el mes pasado al seleccionado:
                          </Typography>
                          <List dense>
                            {objetivosNoActualizados.faltantesPasado.map(
                              (obj) => (
                                <ListItem key={obj.id_objetivo}>
                                  <ListItemText
                                    primary={`${obj.nombre_apellido} - ${obj.nombre_sucursal}`}
                                    secondary={
                                      obj.monto_pesos
                                        ? `$${obj.monto_pesos}`
                                        : "No registrado"
                                    }
                                  />
                                </ListItem>
                              )
                            )}
                          </List>
                        </>
                      )}
                    </Box>
                  )}
                </Box>
                <Stack direction="row">
                  <Grid container direction={{ xs: "column", sm: "row" }}>
                    <Grid item xs={8}>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={handleClose}
                      >
                        Volver
                      </Button>
                    </Grid>
                    <Grid item xs={4}>
                      <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        type="submit"
                      >
                        Guardar
                      </Button>
                    </Grid>
                  </Grid>
                </Stack>
            </Container>
          </DialogContent>
              </form>
        </Box>
      </Dialog>

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default AgregaMontoGeneral;
